import type {
  EntryTemplate,
  AccountInsulin as ApiAccountInsulin,
  AccountMedication as ApiAccountMedication,
  Insulin as ApiInsulin,
  Medication as ApiMedication,
} from "@tandemdiabetes/sugarmate-api-react-client"
import {
  useAccountInsulinLoader,
  useAccountMedicationLoader,
  useInsulinLoader,
  useMedicationLoader,
  useEntryTemplateLoader,
} from "@tandemdiabetes/sugarmate-api-react-client"
import { createSimpleLoadingContextProvider } from "./createSimpleLoadingContextProvider"
import { transformAccountInsulin } from "src/hooks/accountInsulin/transformAccountInsulin"
import { transformAccountMedication } from "src/hooks/accountMedication/transformAccountMedication"
import { transformInsulin } from "src/hooks/insulin/transformInsulin"
import { transformMedication } from "src/hooks/medication/transformMedication"
import {
  CollectionKey,
  UserLocalStorageKey,
} from "src/types"
import type {
  AccountInsulin,
  AccountMedication,
  Insulin,
  Medication,
} from "src/types"

export const [
  InsulinLoadingProvider,
  useInsulinLoading,
  useInsulinReloading,
] =
  createSimpleLoadingContextProvider<ApiInsulin, Insulin>(
    CollectionKey.Insulin,
    UserLocalStorageKey.InsulinsLoadedBefore,
    useInsulinLoader,
    transformInsulin,
  )

export const [
  AccountInsulinLoadingProvider,
  useAccountInsulinLoading,
  useAccountInsulinReloading,
] = createSimpleLoadingContextProvider<ApiAccountInsulin, AccountInsulin>(
  CollectionKey.AccountInsulin,
  UserLocalStorageKey.AccountInsulinsLoadedBefore,
  useAccountInsulinLoader,
  transformAccountInsulin,
)

export const [
  MedicationLoadingProvider,
  useMedicationLoading,
  useMedicationReloading,
] = createSimpleLoadingContextProvider<ApiMedication, Medication>(
  CollectionKey.Medication,
  UserLocalStorageKey.MedicationsLoadedBefore,
  useMedicationLoader,
  transformMedication,
)

export const [
  AccountMedicationLoadingProvider,
  useAccountMedicationLoading,
  useAccountMedicationReloading,
] = createSimpleLoadingContextProvider<ApiAccountMedication, AccountMedication>(
  CollectionKey.AccountMedication,
  UserLocalStorageKey.AccountMedicationsLoadedBefore,
  useAccountMedicationLoader,
  transformAccountMedication,
)

export const [
  EntryTemplateLoadingProvider,
  useEntryTemplateLoading,
  useEntryTemplateReloading,
] = createSimpleLoadingContextProvider<EntryTemplate>(
  CollectionKey.EntryTemplate,
  UserLocalStorageKey.EntryTemplatesLoadedBefore,
  useEntryTemplateLoader,
  (i) => i,
)

